
import React from 'react';
import Switch from '../../../components/ui/Switch';
import { AppIcon } from '../../../components/icons/AppIcon';

type BillingCycle = 'monthly' | 'annually';

interface BillingToggleProps {
    billingCycle: BillingCycle;
    onToggle: () => void;
}

const BillingToggle: React.FC<BillingToggleProps> = ({ billingCycle, onToggle }) => (
    <div
        role="group"
        aria-label="Ciclo de cobrança"
        className="flex flex-col max-md:w-full md:flex-row flex-wrap justify-center items-center max-md:gap-2 md:gap-x-3 gap-y-2 select-none"
    >
        <div className="flex items-center justify-center gap-x-2 md:gap-x-3">
        <button
            type="button"
            className={`text-body-sm font-semibold transition-base cursor-pointer ${
                billingCycle === 'monthly' ? 'text-primary' : 'text-secondary hover:text-text'
            }`}
            onClick={billingCycle === 'annually' ? onToggle : undefined}
            aria-pressed={billingCycle === 'monthly'}
        >
            Mensal
        </button>

        <Switch
            id="billing-toggle"
            checked={billingCycle === 'annually'}
            onChange={() => onToggle()}
            aria-label="Alternar ciclo de cobrança"
        />

        <button
            type="button"
            className={`text-body-sm font-semibold transition-base cursor-pointer ${
                billingCycle === 'annually' ? 'text-primary' : 'text-secondary hover:text-text'
            }`}
            onClick={billingCycle === 'monthly' ? onToggle : undefined}
            aria-pressed={billingCycle === 'annually'}
        >
            Anual
        </button>
        </div>

        <span className="bg-accent-subtle text-accent-dark text-caption font-semibold px-3 py-1 rounded-full inline-flex items-center justify-center gap-1.5 border border-accent/15 shadow-sm max-md:w-full max-md:py-1.5">
            <AppIcon name="tag" className="w-3.5 h-3.5 shrink-0" aria-hidden="true" />
            Economize 2 meses
        </span>
    </div>
);

export default BillingToggle;
